import requestFunctions from "../../functions/requestFunctions";


export const state = {
  COSTS_ITEM: {},
  COSTS_LIST: [],
  COSTS_TABLE_DATA: [],
  COSTS_ARRAY_DATA: [],
  COSTS_TOTAL_ROWS: 0
}

export const getters = {
  GET_COSTS_ITEM: (state) => {
    return state.COSTS_ITEM;
  },
  GET_COSTS_LIST: (state) => {
    return state.COSTS_LIST;
  },
  GET_COSTS_TABLE_DATA: (state) => {
    return state.COSTS_TABLE_DATA;
  },
  GET_COSTS_ARRAY_DATA: (state) => {
    return state.COSTS_ARRAY_DATA;
  },
  GET_COSTS_TOTAL_ROWS: (state) => {
    return state.COSTS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_COSTS_ITEM(state, item) {
    state.COSTS_ITEM = item;
  },

  UPDATE_COSTS_LIST(state, list) {
    
    state.COSTS_LIST = list.data;

    state.COSTS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.COSTS_TABLE_DATA = [];
    state.COSTS_ARRAY_DATA = [];

    list.forEach(el => {

      state.COSTS_TABLE_DATA.push({
        'uuid'   : el.uuid,
        'id'     : el.id,
        'sum'    : el.sum,
        'status' : el.status,                
        'comments'  : el.comments,        
        'shop_name' : el.shop_name,
        'client_type' : el.client_type,
        'company_name': el.company_name,
        'created_at'  : el.created_at,
        'updated_at'  : el.updated_at,
        'cost_item_name'   : el.cost_item_name,
        'marketplace_name' : el.marketplace_name,
      });

      state.COSTS_ARRAY_DATA.push({
        id: el.id,
        uuid: el.uuid,
        cost_item_name: el.cost_item_name,
      });
    });
  },
}

export const actions = {

  async FETCH_COSTS_ITEM({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/costs/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_COSTS_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_COSTS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.tradeanalytic.ru/v1/costs';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_COSTS_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_COSTS_CREATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/costs';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_COSTS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/costs/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_COSTS_DELETE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/costs/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}